// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"808":"c8c72d62","857":"4c7b4d08","884":"aa5f168f"}[chunkId] + ".chunk.css";
};